export const schedule = (state) => {
  return state.schedule
}

export const weekDays = (state) => {
  return state.weekDays
}
